<template>
  <div>
    <HeroCarousel />

    <div class="info-clinique pt-5 pb-5">
      <div class="container">
        <div class="bg-blue p-4 round-10 band">
          <!-- Image on the left -->
          <div class="band-image">
            <div class="bg-white">
              <img :src="veterinaire.veterinary?.image && veterinaire.veterinary?.image.path ? veterinaire.veterinary.image.path : defaultLogo" />
            </div>
          </div>
          
          <!-- Content in the center -->
          <div class="band-content">
            <h3 class="white-color font-20 font-bold">{{ veterinaryInfo.name }}</h3>

            <div class="info-clinique-inner mt-3 d-flex gap-3 align-items-center justify-content-between">
              <p>
                <i class="ti ti-location-pin"></i><span>{{ veterinaryInfo.address }}</span>
              </p>
              <p>
                <i class="ti ti-mobile"></i><span>{{ veterinaryInfo.phoneNumber }}</span>
              </p>
              <p>
                <i class="ti ti-email"></i><span>{{ veterinaryInfo.email }}</span>
              </p>
            </div>
          </div>
          
          <!-- Button on the right -->
          <div class="band-button">
            <a :href="`mailto:${veterinaryInfo.email}`" class="btn btn-orange" target="_blank">{{
              $t("home_client.clinic_info.contact_button")
            }}</a>
          </div>
        </div>
      </div>
    </div>


    <div class="bg-light-1 pt-5 pb-5">
      <div class="container">
        <IncontournablesProduct />
      </div>
    </div>

    <div class="pt-5 pb-5">
      <div class="container">
        <PromotionsCarousel />
      </div>
    </div>

    <div class="pt-5 pb-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <h2 class="font-32 blue-color font-bold text-center">{{ $t("home_client.product_range.title") }}</h2>
            <p
              class="font-16 text-center"
              v-html="$sanitize.sanitizeI18nContent($t('home_client.product_range.description'))"
            ></p>
          </div>
        </div>

        <div class="row mt-5 gamme-boxes">
          <div
            v-for="gamme in gammesStore.gammes.filter(g => g.code !== 'gamme-mixte')"
            :key="gamme.id"
            class="col-lg-3 col-md-4 col-sm-6 mb-4"
          >
            <div class="gamme-box" @click="GoToGamme(gamme)" style="cursor: pointer">
              <div class="gamme-box-image mb-2">
                <img
                  :src="gamme.images && gamme.images.length && gamme.images[0].path ? gamme.images[0].path : equine"
                  :alt="gamme.name"
                  class="img-fluid"
                />
              </div>
              <h3 class="text-center">{{ gamme.name }}</h3>
            </div>
          </div>
          <div v-if="gammesStore.gammes.some(g => g.code === 'gm2')" class="col-lg-3 col-md-4 col-sm-6 mb-4">
            <div class="gamme-box" @click="GoToGammeCroquette()" style="cursor: pointer">
              <div class="gamme-box-image mb-2">
                <img :src="alimentation" :alt="$t('home_client.product_range.categories.food')" class="img-fluid" />
              </div>
              <h3 class="text-center">{{ $t("home_client.product_range.categories.food") }}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="bg-light-1 pt-5 pb-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-7">
            <h2 class="font-32 blue-color font-bold text-center">{{ $t("home_client.loyalty_program.title") }}</h2>
            <p class="font-16 text-center">{{ $t("home_client.loyalty_program.description") }}</p>

            <div class="number-text-block text-center mt-5">
              <h3 class="mb-3">
                <strong class="blue-color">{{ $t("home_client.loyalty_program.conversion.spent") }}</strong>
                <strong class="orange-color"> {{ $t("home_client.loyalty_program.conversion.points") }}</strong>
              </h3>
              <h3 class="mb-5">
                <strong class="blue-color">{{ $t("home_client.loyalty_program.conversion.points_value") }}</strong>
                <strong class="orange-color">{{ $t("home_client.loyalty_program.conversion.discount") }}</strong>
              </h3>

              <a href="#" class="btn btn-orange">{{ $t("home_client.loyalty_program.discover_button") }}</a>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="pt-5 pb-5">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-8">
            <h2 class="font-32 blue-color font-bold text-center">{{ $t("home_client.recommendations.title") }}</h2>

            <div class="row mt-5 justify-content-center align-items-center">
              <div class="col-lg-4">
                <div class="d-flex flex-column justify-content-center gap-3 align-items-center">
                  <img :src="support" class="w-30" />
                  <p class="text-center font-bold blue-color">
                    {{ $t("home_client.recommendations.features.customer_service") }}
                  </p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="d-flex flex-column justify-content-center gap-3 align-items-center">
                  <img :src="pays" class="w-30" />
                  <p class="text-center font-bold blue-color">
                    {{ $t("home_client.recommendations.features.made_in_france") }}
                  </p>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="d-flex flex-column justify-content-center gap-3 align-items-center">
                  <img :src="delivery" class="w-30" />
                  <p class="text-center font-bold blue-color">
                    {{ $t("home_client.recommendations.features.delivery") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="question-list bg-light-1">
      <div class="container">
        <div class="content col-sm-12 col-md-12 col-lg-12">
          <Question />
        </div>
      </div>
    </div>

    <div class="pt-5 pb-5">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-5">
            <h2 class="font-32 blue-color font-bold">{{ $t("home_client.newsletter.title") }}</h2>
            <p>{{ $t("home_client.newsletter.description") }}</p>
          </div>

          <div class="col-lg-5 offset-lg-2">
            <form @submit="submitNewsletter">
              <div class="form-input email-input">
                <input
                  type="email"
                  :placeholder="$t('home_client.newsletter.placeholder')"
                  class="form-control"
                  v-model="email"
                  :class="{ 'is-invalid': errors.email }"
                />
                <button
                  type="submit"
                  class="btn btn-orange btn-circle"
                  :disabled="!isFormValid || isSubmitting"
                  :class="{ disabled: !isFormValid || isSubmitting }"
                  :title="
                    isSubmitting
                      ? $t('home_client.newsletter.buttons.subscribing')
                      : $t('home_client.newsletter.buttons.subscribe')
                  "
                >
                  <img :src="send" v-if="!isSubmitting" />
                  <span v-else class="spinner-border spinner-border-sm" role="status"></span>
                </button>
              </div>

              <div v-if="errors.email" class="text-danger small mt-1">
                {{ errors.email }}
              </div>

              <p class="mt-3">{{ $t("home_client.newsletter.question") }}</p>

              <div class="d-flex gap-3">
                <label
                  v-for="animal in availableAnimals"
                  :key="animal.id"
                  :class="['check-button', { active: selected.includes(animal.id) }]"
                >
                  <input type="checkbox" :value="animal.id" v-model="selected" hidden />
                  <span class="label-text">{{ animal.name }}</span>
                  <span class="check-icon" v-if="selected.includes(animal.id)">
                    <i class="ti ti-check-box ps-2"></i>
                  </span>
                </label>
              </div>
              <div v-if="errors.animals" class="text-danger small mt-1">
                {{ errors.animals }}
              </div>
              <div v-if="isSubmitted" class="alert alert-success mt-3">
                {{ $t("home_client.newsletter.success_message") }}
              </div>

              <p
                class="blue-color mt-3"
                v-html="$sanitize.sanitizeI18nContent($t('home_client.newsletter.privacy'))"
              ></p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import support from "@/assets/images/support.svg";
  import pays from "@/assets/images/pays.svg";
  import delivery from "@/assets/images/delivery.svg";
  import send from "@/assets/images/send.svg";
  import Question from "@/components/Question.vue";
  import HeroCarousel from "@/components/e-supplyvet/HeroCarousel.vue";
  import IncontournablesProduct from "@/components/IncontournablesProduct.vue";
  import PromotionsCarousel from "@/components/e-supplyvet/PromotionsCarousel.vue";
  import { useRegisterStore } from "@/stores/register";
  import { useGammesStore } from "@/stores/gammesStore";
  import { storeToRefs } from "pinia";
  import { getAnimalTypes, subscribeNewsletter } from "@/api/newsletter";
  import defaultLogo from "@/assets/images/doctor.svg";
  import equine from "@/assets/images/equine.png";
  import alimentation from "@/assets/images/alimentation.png";

  export default {
    name: "HomePageClient",
    components: {
      Question,
      HeroCarousel,
      IncontournablesProduct,
      PromotionsCarousel,
    },
    data() {
      return {
        // Store instances
        registerStore: useRegisterStore(),
        gammesStore: useGammesStore(),
        equine,
        // Static assets
        support,
        pays,
        send,
        delivery,
        defaultLogo,
        // Newsletter form data
        email: "",
        animalTypes: [],
        availableAnimals: [],
        selected: [],
        isLoadingAnimals: true,
        isSubmitting: false,
        isSubmitted: false,
        alimentation,
        errors: {
          email: "",
          animals: "",
        },
      };
    },
    computed: {
      // Reactive store states from gammesStore
      gammes() {
        return storeToRefs(this.gammesStore).gammes;
      },
      loading() {
        return storeToRefs(this.gammesStore).loading;
      },
      error() {
        return storeToRefs(this.gammesStore).error;
      },
      // Veterinary info from registerStore
      veterinaire() {
        return this.registerStore.Veterinaire;
      },
      veterinaryInfo() {
        const clientInfo = this.registerStore.clientInfo;
        const veterinarian = clientInfo.veterinarian || {};
        const veterinarianName = clientInfo.veterinary?.lastName || {};
        const address = veterinarian.address || {};
        return {
          name: veterinarianName || "Clinique Vétérinaire",
          address: address.complete || address.street || "",
          phoneNumber: veterinarian.phoneNumber || "",
          email: veterinarian.email || "",
        };
      },
      isFormValid() {
        return this.email && this.isValidEmail(this.email) && this.selected.length > 0;
      },
    },
    mounted() {
      // Fetch all required data concurrently
      Promise.all([this.registerStore.fetchClientInfo(), this.gammesStore.fetchGammes(), this.loadAnimalTypes()]).catch(
        error => {
          console.error("Error during mounted data fetching:", error);
        }
      );
    },
    methods: {
      async GoToGammeCroquette() {
        try {
          // Navigate to taxonList with a placeholder slug and tag query parameter
          this.$router.push({
            name: "taxonList",
            params: { slug: "croquette" }, // Placeholder slug to satisfy route
            query: { tag: "croquette" },
          });
        } catch (error) {
          console.error("Error navigating to croquette products:", error);
          if (this.$toast) {
            this.$toast.error(this.$t("home_client.errors.navigation_failed"));
          }
        }
      },
      GoToGamme(gamme) {
        const slug = `${gamme.id}-${gamme.slug}`;
        this.$router.push({ name: "taxonList", params: { slug } });
      },
      async loadAnimalTypes() {
        try {
          const response = await getAnimalTypes();
          this.animalTypes = response.data;
          this.availableAnimals = this.animalTypes;
        } catch (error) {
          console.error("Erreur chargement types animaux:", error);
          this.availableAnimals = [];
        } finally {
          this.isLoadingAnimals = false;
        }
      },
      isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      },
      validateForm() {
        this.errors = { email: "", animals: "" };
        if (!this.email) {
          this.errors.email = this.$t("home_client.newsletter.errors.email_required");
          return false;
        }
        if (!this.isValidEmail(this.email)) {
          this.errors.email = this.$t("home_client.newsletter.errors.email_invalid");
          return false;
        }
        if (this.selected.length === 0) {
          this.errors.animals = this.$t("home_client.newsletter.errors.animals_required");
          return false;
        }
        return true;
      },
      async submitNewsletter() {
        if (!this.validateForm()) {
          return;
        }
        this.isSubmitting = true;
        try {
          const payload = {
            email: this.email,
            animalTypeIds: this.selected,
          };
          await subscribeNewsletter(payload);
          this.isSubmitted = true;
          if (this.$toast) {
            this.$toast.success(this.$t("home_client.newsletter.success_message"));
          }
          setTimeout(() => {
            this.isSubmitted = false;
          }, 4000);
          this.resetForm();
        } catch (error) {
          console.error("Erreur inscription newsletter:", error);
          if (this.$toast) {
            this.$toast.error(this.$t("home_client.newsletter.errors.subscription_failed"));
          }
        } finally {
          this.isSubmitting = false;
        }
      },
      resetForm() {
        this.email = "";
        this.selected = [];
        this.errors = { email: "", animals: "" };
      },
    },
  };
</script>
<style scoped>

  .band {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 20px;
}

.band-image {
  flex: 0 0 auto;
}

.band-content {
  flex: 1 1 auto;
  text-align: center;
}

.band-button {
  flex: 0 0 auto;
}

.bg-white {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px;
  border-radius: 8px;
 
}

.bg-white img {
  max-width: 150px;
  max-height: 100px;
  object-fit: contain;
   border-radius: 8px;
}

.info-clinique-inner {
  flex-wrap: wrap;
  justify-content: center !important;
}

.info-clinique-inner p {
  margin-bottom: 0.5rem;
}

/* Responsive adjustments */
@media (max-width: 992px) {
  .band {
    flex-direction: column;
    text-align: center;
  }
  
  .info-clinique-inner {
    flex-direction: column;
    gap: 10px !important;
  }
  
  .band-content {
    order: 2;
  }
  
  .band-image {
    order: 1;
  }
  
  .band-button {
    order: 3;
  }
}

.gamme-boxes {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
</style>
